import { gql as individual_gql } from '@/modes/individual/gql';
import { gql as company_gql } from '@/modes/company/gql';
import { gql as waterSupplier_gql } from '@/modes/waterSupplier/gql';
import { ResultOf } from 'gql.tada';
import { Merge } from '@/helpers/merge-type';

export const GET_FEE_AND_DEFAULT_PAYMENT_METHOD = company_gql(`#graphql
  query GetFeeAndDefaultPaymentMethod($assignmentId: ID!) {
    stripePlatformCustomer {
      defaultPaymentMethodId
    }
    inboundAssignments(where: { id: $assignmentId }) {
      id
      vendorSubmissionFee
    }
  }
`);

export const GET_INBOUND_ASSIGNMENT_COMPANY = company_gql(`#graphql
  query GetInboundAssignment($where: JSON) {
    inboundAssignments(where: $where) {
      id
      status
      jobId
      job {
        id
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        formData
        attachments {
          id
          contentType
          url
          thumb(size: 500)
          profile {
            id
            name
          }
          created
        }
        siteContact {
          id
          name
          address {
            id
            street1
            street2
            city
            state
            zip
            zipExt
          }
          email
          phone
          notes
        }
        comments {
          id
          type
          visibility
          comment
          profile {
            id
            name
          }
          created
        }
        statusChanges {
          id
          fromStatus
          toStatus
          profile {
            id
            name
          }
          created
        }
        backflowTest {
          jobId
          testerName
          waterSupplier {
            profileId
            rpCheck2Type
            profile {
              name
            }
          }
          dateTested
          finalResult
          originalBackflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                name
              }
            }
            serialNumber
            size
            type
            location
            installDate
          }
          backflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                id
                name
              }
            }
            serialNumber
            size
            type
            location
            installDate
            waterService {
              id
              meterNumber
              pin
            }
          }
        }
      }
      vendorSubmissionFee
      customer {
        id
        profile {
          id
          name
          contactAddress {
            id
            street1
            street2
            city
            state
            zip
          }
          emails {
            subType
            value
          }
          phones {
            subType
            value
            extension
          }
        }
        notes
      }
      child {
        id
        vendorProfile {
          id
          name
          type
        }
      }
    }
  }
`);

export const GET_INBOUND_ASSIGNMENT_WATER_SUPPLIER = waterSupplier_gql(`#graphql
  query GetInboundAssignment($where: JSON) {
    inboundAssignments(where: $where) {
      id
      status
      jobId
      job {
        id
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        formData
        attachments {
          id
          contentType
          url
          thumb(size: 500)
          profile {
            id
            name
          }
          created
        }
        siteContact {
          id
          name
          address {
            id
            street1
            street2
            city
            state
            zip
            zipExt
          }
          email
          phone
          notes
        }
        comments {
          id
          type
          visibility
          comment
          profile {
            id
            name
          }
          created
        }
        statusChanges {
          id
          fromStatus
          toStatus
          profile {
            id
            name
          }
          created
        }
        backflowTest {
          jobId
          testerName
          testerId
          waterSupplier {
            profileId
            rpCheck2Type
            profile {
              name
            }
          }
          dateTested
          finalResult
          originalBackflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                name
              }
            }
            serialNumber
            size
            type
            location
            installDate
          }
          backflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                id
                name
              }
            }
            serialNumber
            size
            type
            location
            installDate
            waterService {
              id
              meterNumber
              pin
              siteNumber
            }
          }
        }
      }
      vendorSubmissionFee
      customer {
        id
        profile {
          id
          name
          contactAddress {
            id
            street1
            street2
            city
            state
            zip
          }
          emails {
            subType
            value
          }
          phones {
            subType
            value
            extension
          }
        }
        notes
      }
      child {
        id
        vendorProfile {
          id
          name
          type
        }
      }
    }
  }
`);

export const GET_INBOUND_ASSIGNMENT_INDIVIDUAL = individual_gql(`#graphql
  query GetInboundAssignment($where: JSON) {
    inboundAssignments(where: $where) {
      id
      status
      jobId
      job {
        id
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        formData
        attachments {
          id
          contentType
          url
          thumb(size: 500)
          profile {
            id
            name
          }
          created
        }
        siteContact {
          id
          name
          address {
            id
            street1
            street2
            city
            state
            zip
            zipExt
          }
          email
          phone
          notes
        }
        comments {
          id
          type
          visibility
          comment
          profile {
            id
            name
          }
          created
        }
        statusChanges {
          id
          fromStatus
          toStatus
          profile {
            id
            name
          }
          created
        }
        backflowTest {
          jobId
          testerName
          waterSupplier {
            profileId
            rpCheck2Type
            profile {
              name
            }
          }
          dateTested
          finalResult
          originalBackflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                name
              }
            }
            serialNumber
            size
            type
            location
            installDate
          }
          backflowAssembly {
            id
            modelId
            model {
              id
              name
              backflowAssemblyMake {
                id
                name
              }
            }
            serialNumber
            size
            type
            location
            installDate
          }
        }
      }
      vendorSubmissionFee
      customer {
        id
        profile {
          id
          name
          contactAddress {
            id
            street1
            street2
            city
            state
            zip
          }
          emails {
            subType
            value
          }
          phones {
            subType
            value
            extension
          }
        }
        notes
      }
    }
  }
`);

export const ASSIGN_JOB = company_gql(`#graphql
  mutation AssignJob(
    $assignmentId: ID!
    $vendorProfileId: ID!
    $dueDate: String
  ) {
    assignInboundAssignments(
      assignmentIds: [$assignmentId]
      vendorProfileId: $vendorProfileId
      dueDate: $dueDate
    ) {
      id
      status
      child {
        id
        status
        vendorProfile {
          id
          name
        }
        due
      }
    }
  }
`);

export const ASSIGN_JOB_WS = waterSupplier_gql(`#graphql
  mutation AssignJob(
    $assignmentId: ID!
    $vendorProfileId: ID!
    $testerProfileId: ID
    $dueDate: String
  ) {
    assignInboundAssignments(
      assignmentIds: [$assignmentId]
      vendorProfileId: $vendorProfileId
      testerProfileId: $testerProfileId
      dueDate: $dueDate
    ) {
      id
      status
      child {
        id
        status
        vendorProfile {
          id
          name
        }
        due
      }
    }
  }
`);

export const SET_JOB_FORM_VALUES = individual_gql(`#graphql
  mutation SetJobFormValues($jobId: ID!, $values: JSON!) {
    setJobFormValues(jobId: $jobId, values: $values) {
      id
    }
  }
`);

export const SET_ASSIGNMENT_STATUS = individual_gql(`#graphql
  mutation SetInboundAssignmentStatus(
    $assignmentId: ID!
    $newStatus: AssignmentStatus!
    $oldStatus: AssignmentStatus!
  ) {
    setInboundAssignmentStatus(
      assignmentId: $assignmentId
      newStatus: $newStatus
      oldStatus: $oldStatus
    ) {
      id
      status
      jobId
      completed
      submitted
      job {
        id
      }
    }
  }
`);

type JobCompany = ResultOf<
  typeof GET_INBOUND_ASSIGNMENT_COMPANY
>['inboundAssignments'][number]['job'];
type JobWaterSupplier = ResultOf<
  typeof GET_INBOUND_ASSIGNMENT_WATER_SUPPLIER
>['inboundAssignments'][number]['job'];
type JobIndividual = ResultOf<
  typeof GET_INBOUND_ASSIGNMENT_INDIVIDUAL
>['inboundAssignments'][number]['job'];
export type Job = Merge<Merge<JobCompany, JobWaterSupplier>, JobIndividual>;
export type BackflowTest = NonNullable<Job['backflowTest']>;
export type AssemblyInfo = NonNullable<BackflowTest['backflowAssembly']>;
export type JobComment = NonNullable<Job['comments']>[number];
export type JobStatusChange = NonNullable<Job['statusChanges']>[number];
export type JobAttachment = NonNullable<Job['attachments']>[number];

type CustomerCompany = ResultOf<
  typeof GET_INBOUND_ASSIGNMENT_COMPANY
>['inboundAssignments'][number]['customer'];
type CustomerWaterSupplier = ResultOf<
  typeof GET_INBOUND_ASSIGNMENT_WATER_SUPPLIER
>['inboundAssignments'][number]['customer'];
type CustomerIndividual = ResultOf<
  typeof GET_INBOUND_ASSIGNMENT_INDIVIDUAL
>['inboundAssignments'][number]['customer'];
export type Customer = Merge<
  Merge<CustomerCompany, CustomerWaterSupplier>,
  CustomerIndividual
>;

type VendorProfileCompany = NonNullable<
  ResultOf<
    typeof GET_INBOUND_ASSIGNMENT_COMPANY
  >['inboundAssignments'][number]['child']
>['vendorProfile'];
type VendorProfileWaterSupplier = NonNullable<
  ResultOf<
    typeof GET_INBOUND_ASSIGNMENT_WATER_SUPPLIER
  >['inboundAssignments'][number]['child']
>['vendorProfile'];
export type VendorProfile = Merge<
  VendorProfileCompany,
  VendorProfileWaterSupplier
>;
